import React, { useEffect } from 'react';
import { useAppStore } from '@/store';
import { Button } from '@/components/ui';
import { TelegramUtils } from '@/utils/telegram';
import { cn } from '@/utils';

interface MatchCelebrationModalProps {
  userId: string;
  onClose: () => void;
  onOpenChat: () => void;
}

const MatchCelebrationModal: React.FC<MatchCelebrationModalProps> = ({
  userId,
  onClose,
  onOpenChat,
}) => {
  // Trigger haptic feedback when modal opens
  useEffect(() => {
    TelegramUtils.haptic.success();
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/80 backdrop-blur-sm animate-fade-in safe-area-y">
      <div className="w-full max-w-sm bg-tg-bg border border-white/10 rounded-3xl p-8 text-center animate-scale-in">
        {/* Animated celebration icon */}
        <div className="mb-6 relative">
          {/* Outer pulsing ring */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 bg-primary-400/20 rounded-full animate-ping" style={{ animationDuration: '2s' }} />
          </div>
          
          {/* Main icon */}
          <div className="relative flex items-center justify-center">
            <div className="w-24 h-24 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center shadow-xl">
              <span className="text-5xl">💕</span>
            </div>
          </div>
          
          {/* Floating particles */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="absolute -top-4 -left-4 text-3xl animate-bounce" style={{ animationDelay: '0s', animationDuration: '1.5s' }}>
              ✨
            </div>
            <div className="absolute -top-4 -right-4 text-3xl animate-bounce" style={{ animationDelay: '0.2s', animationDuration: '1.5s' }}>
              ⭐
            </div>
            <div className="absolute -bottom-4 -left-4 text-3xl animate-bounce" style={{ animationDelay: '0.4s', animationDuration: '1.5s' }}>
              💫
            </div>
            <div className="absolute -bottom-4 -right-4 text-3xl animate-bounce" style={{ animationDelay: '0.6s', animationDuration: '1.5s' }}>
              ✨
            </div>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-3xl font-bold text-white mb-2">
          Это совпадение!
        </h2>
        
        {/* Subtitle */}
        <p className="text-neutral-400 mb-8">
          Вы понравились друг другу. Начните общение прямо сейчас!
        </p>

        {/* Actions */}
        <div className="space-y-3">
          <Button
            onClick={onOpenChat}
            className="w-full h-14 bg-white text-black hover:bg-neutral-100 font-bold text-base rounded-2xl transition-all active:scale-95"
          >
            Написать сообщение
          </Button>
          
          <button
            onClick={onClose}
            className="w-full h-12 text-neutral-400 hover:text-white font-medium text-sm transition-colors"
          >
            Продолжить свайпать
          </button>
        </div>
      </div>
    </div>
  );
};

export default MatchCelebrationModal;

